import { Pipe, PipeTransform, Directive, OnDestroy, HostListener, Output, EventEmitter, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormState } from './state/form-state';

@Directive({
    selector: 'form[mcbForm]',
    exportAs: 'mcbForm',
})
export class FormDirective {
    @Input() safeNavigation = true;
    @Output() do = new EventEmitter<NgForm>();

    constructor(private form: NgForm, private formState: FormState) {
    }

    @HostListener('submit', ['$event']) onSubmit(e) {
        if (this.form.valid) {
            this.formState.saved = true;
            this.do.emit(this.form);
        }
    }

    @HostListener('input', ['$event']) onInput(e) {
        if (this.safeNavigation) {
            this.formState.saved = false;
        }
    }
}
